import { useEffect, useMemo, useState } from 'react'
import { Button, DatePicker, Layout, Switch } from 'antd'
import { Content, Header } from 'antd/es/layout/layout'
import { DatePickerProps } from 'antd/lib'
import { format, subWeeks } from 'date-fns'
import dayjs, { Dayjs } from 'dayjs'
import styles from './Growth.module.scss'
import Loading from '../../../components/Loading/Loading'
import Table, { IColumn, TableRow } from '../../../components/Table'
import exportSvg from '../../../images/export.svg'
import { getGrowthRecordAsync, getNamedGrowthFiltersAsync, setSelectedRange } from '../../../redux/admin/growth'
import { IGrowthRecord } from '../../../redux/admin/growth/interface'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { StatusEnum } from '../../../redux/type'

const Growth = () => {
  const dispatch = useAppDispatch()
  const growthRecord = useAppSelector((state) => state.admin.growth.growthRecord)
  const selectedRange = useAppSelector((state) => state.admin.growth.selectedRange)
  const growthRecordStatus = useAppSelector((state) => state.admin.growth.growthRecordStatus)
  const [startDate, setStartDate]: any = useState()
  const [endDate, setEndDate]: any = useState()

  const [selectedUtmSource, setSelectedUtmSource] = useState({ label: 'All', value: 'all' })
  const [selectedUtmCampaign, setSelectedUtmCampaign] = useState({ label: 'All', value: 'all' })
  const [selectedUtmMarket, setSelectedUtmMarket] = useState({ label: 'All', value: 'all' })
  const [selectedLoc, setSelectedLoc] = useState({ label: 'All', value: 'all' })
  const [toggleValue, setToggleValue] = useState(true)

  console.log(selectedRange, 'selected range')

  const columns: Array<IColumn> = [
    {
      capitalize: true,
      displayName: 'Name',
      key: 'name',
      size: 30,
    },
    {
      capitalize: true,
      displayName: 'Leads',
      key: 'leads',
      //   size: 20,
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      header: () => <div style={{ textAlign: 'right' }}>Leads</div>,
    },

    {
      capitalize: false,
      displayName: 'Bookings',
      key: 'bookings',
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      header: () => <div style={{ textAlign: 'right' }}>Bookings</div>,
      // size: 20,
    },
    {
      capitalize: false,
      displayName: 'Booking %',
      key: 'bookingPercentage',
      //   size: 20,
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      header: () => <div style={{ textAlign: 'right' }}>Booking %</div>,
    },
    {
      capitalize: false,
      displayName: 'Period',
      key: 'periodBookings',
      //  size: 20,
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      header: () => <div style={{ textAlign: 'right' }}>Period</div>,
    },
    {
      capitalize: true,
      displayName: 'Shows',
      key: 'shows',
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      header: () => <div style={{ textAlign: 'right' }}>Show</div>,
    },
    {
      capitalize: false,
      displayName: 'Show %',
      key: 'showPercentage',
      //   size: 20,
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      header: () => <div style={{ textAlign: 'right' }}>Show %</div>,
    },
    {
      capitalize: true,
      displayName: 'Converts',
      key: 'converts',
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      header: () => <div style={{ textAlign: 'right' }}>Converts</div>,
    },
    {
      capitalize: false,
      displayName: 'Convert %',
      key: 'convertPercentage',
      //  size: 20,
      cell: ({ cell }) => <div style={{ textAlign: 'right' }}>{cell.getValue()}</div>,
      // header: () => <div style={{ textAlign: 'right' }}>Convert %</div>,
    },
  ]

  const currentDate = useMemo(() => {
    return format(new Date(), 'yyyy-MM-dd')
  }, [])

  const oneWeekBeforeDate = useMemo(() => {
    return format(subWeeks(new Date(), 1), 'yyyy-MM-dd')
  }, [])

  const startDateDefaultValue = [dayjs(selectedRange?.startDate || oneWeekBeforeDate)]
  const endDatedefaultValue = [dayjs(selectedRange?.endDate || currentDate)]

  const rows: Array<TableRow> | any = useMemo(() => {
    return (
      growthRecord?.map((d: any) => {
        return {
          name: d?.name || '-',
          utmSource: d?.utmSource || '-',
          utmCampaign: d?.utmCampaign || '-',
          utmMarket: d?.utmMarket || '-',
          loc: d?.loc || '-',
          leads: d?.leads || '-',
          bookings: d?.bookings || '-',
          bookingPercentage: ('' + d?.bookingPercentage).split('.')[0] + '%' || '-',
          periodBookings: d?.periodBookings || '-',
          shows: d?.shows || '-',
          showPercentage: ('' + d?.showPercentage).split('.')[0] + '%' || '-',
          converts: d?.converts || '-',
          convertPercentage: ('' + d?.convertPercentage).split('.')[0] + '%' || '-',
        }
      }) || []
    )
  }, [growthRecord])

  useEffect(() => {
    dispatch(getNamedGrowthFiltersAsync())
  }, [dispatch])

  useEffect(() => {
    dispatch(
      getGrowthRecordAsync({
        startDate: selectedRange?.startDate || oneWeekBeforeDate,
        endDate: selectedRange?.endDate || currentDate,
        source: !selectedUtmSource || selectedUtmSource?.value === 'all' ? undefined : selectedUtmSource?.value,
        campaign: !selectedUtmCampaign || selectedUtmCampaign?.value === 'all' ? undefined : selectedUtmCampaign?.value,
        market: !selectedUtmMarket || selectedUtmMarket?.value === 'all' ? undefined : selectedUtmMarket?.value,
        location: !selectedLoc || selectedLoc?.value === 'all' ? undefined : selectedLoc?.value,
        orgSource: toggleValue,
      }),
    )

    setStartDate(selectedRange?.startDate || oneWeekBeforeDate)
    setEndDate(selectedRange?.endDate || currentDate)
    setSelectedUtmSource({ value: selectedUtmSource?.value || 'all', label: selectedUtmSource.label || 'All' })
    setSelectedUtmCampaign({ value: selectedUtmCampaign?.value || 'all', label: selectedUtmCampaign.label || 'All' })
    setSelectedUtmMarket({ value: selectedUtmMarket?.value || 'all', label: selectedUtmMarket.label || 'All' })
    setSelectedLoc({ value: selectedLoc?.value || 'all', label: selectedLoc.label || 'All' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleValue])

  const onApplyRange = async () => {
    if (startDate && endDate) {
      dispatch(
        getGrowthRecordAsync({
          startDate: startDate,
          endDate: endDate,
          source: !selectedUtmSource || selectedUtmSource?.value === 'all' ? undefined : selectedUtmSource?.value,
          campaign:
            !selectedUtmCampaign || selectedUtmCampaign?.value === 'all' ? undefined : selectedUtmCampaign?.value,
          market: !selectedUtmMarket || selectedUtmMarket?.value === 'all' ? undefined : selectedUtmMarket?.value,
          location: !selectedLoc || selectedLoc?.value === 'all' ? undefined : selectedLoc?.value,
          orgSource: toggleValue,
        }),
      )
      dispatch(setSelectedRange({ startDate: startDate, endDate: endDate }))
    }
  }

  const onChangeStartDate: DatePickerProps<Dayjs[]>['onChange'] = (date, dateString) => {
    setStartDate(dateString)
  }
  const onChangeEndDate: DatePickerProps<Dayjs[]>['onChange'] = (date, dateString) => {
    setEndDate(dateString)
  }

  function convertToCSV(lead: IGrowthRecord[]): Blob {
    const headers = Object.keys(lead[0]).filter((key) => key !== 'id' && key !== 'referralCode' && key !== 'booked')

    const rows = lead.map((obj: any) => {
      return headers.map((key) => {
        const value = obj[key]
        if (value === null) {
          return '-'
        }
        if (typeof value === 'boolean') {
          return value ? 'Yes' : 'No'
        }
        return value
      })
    })

    const headersCapitalized = headers.map((key) => {
      return key.charAt(0).toUpperCase() + key.slice(1)
    })

    const csvString = [headersCapitalized.join(','), ...rows.map((row) => row.join(','))].join('\n')

    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })

    return blob
  }

  const exportReports = async () => {
    const blob = convertToCSV(growthRecord || [])
    if (blob) {
      const url = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = 'KIRO_Growth_Report.csv'

      document.body.appendChild(a)
      a.click()

      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } else {
      alert('Failed to export growth report, Please try again later.')
    }
  }
  return (
    <Layout>
      <Header style={{ borderBottom: '1px solid #2D2C3C' }}></Header>
      <Content style={{ overflowY: 'scroll' }}>
        <div style={{}} className={styles.datePickerContainer}>
          <DatePicker
            placeholder="From"
            className={styles.startDatePicker}
            onChange={onChangeStartDate}
            defaultValue={startDateDefaultValue}
          ></DatePicker>
          <DatePicker
            placeholder="To"
            className={styles.endDatePicker}
            onChange={onChangeEndDate}
            defaultValue={endDatedefaultValue}
          ></DatePicker>
          {/* <Select
            notFoundContent="No source available"
            defaultValue={{ label: 'All', value: 'all' }}
            className={styles.selectStudio}
            value={selectedUtmSource}
            // style={{ width: 317, textTransform: 'capitalize' }}
            dropdownStyle={{ textTransform: 'capitalize' }}
            placeholder={'Select Source'}
            options={namedGrowthFilters.utmSource.map((source) => ({ label: source, value: source }))}
            onChange={(o, v: any) => {
              console.log(o, v, 'options and value')
              setSelectedUtmSource({ value: v.value, label: v.label })
            }}
            suffixIcon={<img src={Arrow} alt="arrowDown" style={{ marginTop: '0.3rem' }} />}
          ></Select> */}
          {/* <Select
            notFoundContent="No medium available"
            defaultValue={{ label: 'All', value: 'all' }}
            className={styles.selectStudio}
            value={selectedStudio}
            dropdownStyle={{ textTransform: 'capitalize' }}
            placeholder={'Select Medium'}
            options={namedGrowthFilters.utmMedium.map((medium) => ({ label: medium, value: medium }))}
            onChange={(o, v: any) => {
              console.log(o, v, 'options and value')
              setSelectedUtmMedium({ value: v.value, label: v.label })
            }}
            suffixIcon={<img src={Arrow} alt="arrowDown" style={{ marginTop: '0.3rem' }} />}
          ></Select> */}
          {/* <Select
            notFoundContent="No campaign available"
            defaultValue={{ label: 'All', value: 'all' }}
            className={styles.selectStudio}
            value={selectedUtmCampaign}
            // style={{ width: 317, textTransform: 'capitalize' }}
            dropdownStyle={{ textTransform: 'capitalize' }}
            placeholder={'Select Campaign'}
            options={namedGrowthFilters.utmCampaign.map((campaign) => ({ label: campaign, value: campaign }))}
            onChange={(o, v: any) => {
              console.log(o, v, 'options and value')
              setSelectedUtmCampaign({ value: v.value, label: v.label })
            }}
            suffixIcon={<img src={Arrow} alt="arrowDown" style={{ marginTop: '0.3rem' }} />}
          ></Select> */}
          {/* <Select
            notFoundContent="No content available"
            defaultValue={{ label: 'All', value: 'all' }}
            className={styles.selectStudio}
            value={selectedStudio}
            // style={{ width: 317, textTransform: 'capitalize' }}
            dropdownStyle={{ textTransform: 'capitalize' }}
            placeholder={'Select Content'}
            options={namedGrowthFilters.utmContent.map((content) => ({ label: content, value: content }))}
            onChange={(o, v: any) => {
              console.log(o, v, 'options and value')
              setSelectedUtmContent({ value: v.value, label: v.label })
            }}
            suffixIcon={<img src={Arrow} alt="arrowDown" style={{ marginTop: '0.3rem' }} />}
          ></Select> */}
          {/* <Select
            notFoundContent="No market available"
            defaultValue={{ label: 'All', value: 'all' }}
            className={styles.selectStudio}
            value={selectedUtmMarket}
            // style={{ width: 317, textTransform: 'capitalize' }}
            dropdownStyle={{ textTransform: 'capitalize' }}
            placeholder={'Select Market'}
            options={namedGrowthFilters.utmMarket.map((market) => ({ label: market, value: market }))}
            onChange={(o, v: any) => {
              console.log(o, v, 'options and value')
              setSelectedUtmMarket({ value: v.value, label: v.label })
            }}
            suffixIcon={<img src={Arrow} alt="arrowDown" style={{ marginTop: '0.3rem' }} />}
          ></Select> */}
          {/* <Select
            notFoundContent="No location available"
            defaultValue={{ label: 'All', value: 'all' }}
            className={styles.selectStudio}
            value={selectedLoc}
            dropdownStyle={{ textTransform: 'capitalize' }}
            placeholder={'Select Location'}
            options={namedGrowthFilters.loc.map((loc) => ({ label: loc, value: loc }))}
            onChange={(o, v: any) => {
              console.log(o, v, 'options and value')
              setSelectedLoc({ value: v.value, label: v.label })
            }}
            suffixIcon={<img src={Arrow} alt="arrowDown" style={{ marginTop: '0.3rem' }} />}
          ></Select> */}
          <Button children={'Apply'} type="primary" className={styles.applyBtn} onClick={onApplyRange}></Button>
          <div className={styles.toggleContainer}>
            <Switch
              checked={toggleValue}
              onChange={(checked) => {
                setToggleValue(checked)
              }}
              style={{ background: !toggleValue ? '#e33939' : '' }}
            />
          </div>
        </div>
        {/* {growthRecordStatus === StatusEnum.Success && (
          <div style={{ padding: 20 }}>
            <div className={styles.summaryTitle}>Summary</div>
            <Row justify={'start'} className={styles.summaryContainer} style={{ marginLeft: '1rem' }}>
              <Col
                className={styles.summaryCard}
                xs={{ span: 17 }}
                sm={{ span: 17 }}
                md={{ span: 11 }}
                lg={{ span: 11 }}
                xl={{ span: 5 }}
                xxl={{ span: 4 }}
              >
                <div className={styles.sumContainer}>
                  <div className={styles.titleColumn}>
                    <div className={styles.reportTitle}>Total Leads : </div>
                    <div className={styles.reportTitle}>Leads from Meta :</div>
                    <div className={styles.reportTitle}>Leads from Google :</div>
                    <div className={styles.reportTitle}>Leads from Referrals :</div>
                  </div>
                  <div className={styles.amountColumn}>
                    <div className={styles.reportValue}>{growthRecord?.summary?.lead?.total ?? '-'}</div>
                    <div className={styles.reportValue}>{growthRecord?.summary?.lead?.meta ?? '-'}</div>
                    <div className={styles.reportValue}>{growthRecord?.summary?.lead?.google ?? '-'}</div>
                    <div className={styles.reportValue}>{growthRecord?.summary?.lead?.referral ?? '-'}</div>
                  </div>
                </div>
              </Col>
              <Col
                className={styles.summaryCard}
                xs={{ span: 17 }}
                sm={{ span: 17 }}
                md={{ span: 11 }}
                lg={{ span: 11 }}
                xl={{ span: 5 }}
                xxl={{ span: 4 }}
              >
                <div className={styles.sumContainer}>
                  <div className={styles.titleColumn}>
                    <div className={styles.reportTitle}>Booking % (Total) : </div>
                    <div className={styles.reportTitle}>Booking % (Meta) : </div>
                    <div className={styles.reportTitle}>Booking % (Google) : </div>
                    <div className={styles.reportTitle}>Booking % (Referral) : </div>
                  </div>
                  <div className={styles.amountColumn}>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.bookings?.total ? `${growthRecord?.summary?.bookings?.total} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.bookings?.meta ? `${growthRecord?.summary?.bookings?.meta} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.bookings?.google ? `${growthRecord?.summary?.bookings?.google} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.bookings?.referral
                        ? `${growthRecord?.summary?.bookings?.referral} %`
                        : '-'}
                    </div>
                  </div>
                </div>
              </Col>

              <Col
                className={styles.summaryCard}
                xs={{ span: 17 }}
                sm={{ span: 17 }}
                md={{ span: 11 }}
                lg={{ span: 11 }}
                xl={{ span: 5 }}
                xxl={{ span: 4 }}
              >
                <div className={styles.sumContainer}>
                  <div className={styles.titleColumn}>
                    <div className={styles.reportTitle}>Show % (Total) : </div>
                    <div className={styles.reportTitle}>Show % (Meta) : </div>
                    <div className={styles.reportTitle}>Show % (Google) : </div>
                    <div className={styles.reportTitle}>Show % (Referral) : </div>
                  </div>
                  <div className={styles.amountColumn}>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.shows?.total ? `${growthRecord?.summary?.shows?.total} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.shows?.meta ? `${growthRecord?.summary?.shows?.meta} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.shows?.google ? `${growthRecord?.summary?.shows?.google} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.shows?.referral ? `${growthRecord?.summary?.shows?.referral} %` : '-'}
                    </div>
                  </div>
                </div>
              </Col>

              <Col
                className={styles.summaryCard}
                xs={{ span: 17 }}
                sm={{ span: 17 }}
                md={{ span: 11 }}
                lg={{ span: 11 }}
                xl={{ span: 5 }}
                xxl={{ span: 4 }}
              >
                <div className={styles.sumContainer}>
                  <div className={styles.titleColumn}>
                    <div className={styles.reportTitle}>Convert % (Total) : </div>
                    <div className={styles.reportTitle}>Convert % (Meta) : </div>
                    <div className={styles.reportTitle}>Convert % (Google) : </div>
                    <div className={styles.reportTitle}>Convert % (Referral) : </div>
                  </div>
                  <div className={styles.amountColumn}>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.converts?.total ? `${growthRecord?.summary?.converts?.total} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.converts?.meta ? `${growthRecord?.summary?.converts?.meta} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.converts?.google ? `${growthRecord?.summary?.converts?.google} %` : '-'}
                    </div>
                    <div className={styles.reportValue}>
                      {growthRecord?.summary?.converts?.referral
                        ? `${growthRecord?.summary?.converts?.referral} %`
                        : '-'}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )} */}
        {
          <div style={{ padding: 20 }}>
            {growthRecordStatus === StatusEnum.Pending && <Loading style={{ background: 'none' }}></Loading>}
            {growthRecordStatus === StatusEnum.Success && (
              <Table
                columns={columns}
                rows={rows}
                buttonText="Export"
                svg={exportSvg}
                totalPageCount={1}
                currentPage={1}
                onRowClick={(id) => {}}
                onButtonClick={() => {
                  exportReports()
                }}
                onPageChange={(page, pageSize) => {}}
                initalButtonChildren={'No Record Found'}
                noDataFoundContent="No Record Found"
                onInitialButtonClicked={() => {}}
              ></Table>
            )}
          </div>
        }
      </Content>
    </Layout>
  )
}

export default Growth
